export default "__VITE_ASSET__92fb014e__"